export const SSO_POST_LOGIN_URL_STORAGE_KEY = 'sso_post_login_url';

// Redirect-based replacement for satellizer's popup Google/Microsoft OAuth flow -
// the popup's window.closed polling has the same Cross-Origin-Opener-Policy issue
// the Auth0 SSO flow above had.
export const SOCIAL_OAUTH_PENDING_PROVIDER_STORAGE_KEY = 'social_oauth_pending_provider';
export const SOCIAL_OAUTH_STATE_STORAGE_PREFIX = 'social_oauth_state_';

// Query param appended when a redirect-based login (Auth0 or social) fails and sends
// the user back to the login page - authentication.login's url must declare it (see
// authentication.config.ts) or ui-router strips it before login-view can read it.
export const AUTH_ERROR_QUERY_PARAM = 'authError';
